import alt from '../../alt';
import si from 'si';
import MessageActions from '../../Message/MessageActions';

class ChangePasswordActions {
    constructor() {
    }

    changeField(name, value){
        var diff = {};
        diff[name] = value;
        return diff;
    }

    validatePasswordRequirements(password) {
        si.validatePasswordRequirements('', password).then(this.validatePasswordRequirementsSuccess, this.validatePasswordRequirementsSuccess)
        return false;
    }

    validatePasswordRequirementsSuccess(result) {
        return result;
    }

    submit(passwordData) {
      si.changePassword(passwordData).then(this.submitSuccess, this.registerErrors);
      return passwordData;
    }

    submitSuccess(result) {
      if(result.oldPasswordInvalid) {
          MessageActions.addErrorMessage(window.jenkon.resources["PWS.ChangePassword.LoginNotFound"]);
      } else if (result.passwordChanged) {
          return result;
      }
    }

    reset() {
      return true;
    }

    registerErrors(error) {
     //console.log(error);
    }

}

export default alt.createActions(ChangePasswordActions);



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/ChangePassword/ChangePasswordActions.js